import Vue from 'vue'
import App from '@/components/app/App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import moment from 'moment-timezone'
import VuetifyConfirm from 'vuetify-confirm'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'


Vue.config.productionTip = false

moment.locale('ru')
moment.tz.setDefault('Europe/Moscow')

Vue.use(VueTelInputVuetify, { vuetify })
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Подтвердить',
  buttonFalseText: 'Отмена',
  color: 'blue',
  icon: '',
  title: 'Подтвердите',
  width: 350,
  property: '$confirm'
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
